var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 7H4V5h16zM6 20h12V8H6zm4-16h4V3h-4zm10.5 0H15V2.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V4H3.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H5v12.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V8h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5M12 18a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-1 0v7a.5.5 0 0 0 .5.5m3 0a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-1 0v7a.5.5 0 0 0 .5.5m-6 0a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-1 0v7a.5.5 0 0 0 .5.5",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;